// extracted by mini-css-extract-plugin
export default {"root":"Santa_root__ZIRDt","info":"Santa_info__aC5bx","logoGamePad":"Santa_logoGamePad__qfgkw","logoShoe":"Santa_logoShoe__HSiC0"};